function displayWindowSize(){
  var w = document.documentElement.clientWidth;
  return w;
}
var searchIcon = document.querySelector(".header__icon--search");
var searchCloseIcon = document.querySelector("button.search-close");
var searchContainer = document.querySelector(".searchbox_container");

if(displayWindowSize() < 1200){
  searchfunctionality();
} else {
  searchContainer.style.display = 'block';
}
window.addEventListener('resize', function(event) {
  if(displayWindowSize() < 1200){
    searchfunctionality();
  } else {
    searchContainer.style.display = 'block';
  }
});

function searchfunctionality (){
  //searchContainer.style.display = 'none';
  searchIcon.addEventListener("click", function(event) {
    searchContainer.style.display = 'block';
    searchContainer.setAttribute("searchopen", "");
  });
  searchCloseIcon.addEventListener("click", function(event) {
    searchContainer.style.display = 'none';
    searchContainer.removeAttribute("searchopen");
  });
}